import React from "react";

import dependencyInjection from "@common/util/dependencyInjection";
import ReleaseMetricDetailsLayout from "@main/pages/Release/views/MetricDetails/ReleaseMetricDetailsLayout";
import ReleasesPageView from "@main/pages/Release/views/ReleasesPageView";

import { AnalyticsService } from "./services/Analytics.service";

interface Services {
  analyticsService: AnalyticsService;
}

const analyticsService = new AnalyticsService();

const [AnalyticsDependencyProvider, useAnalyticsDeps] = dependencyInjection<Services>({
  services: {
    analyticsService,
  },
});

export function ReleasesPage() {
  return (
    <AnalyticsDependencyProvider>
      <ReleasesPageView />
    </AnalyticsDependencyProvider>
  );
}

export function ReleaseMetricDetailsPage() {
  return (
    <AnalyticsDependencyProvider>
      <ReleaseMetricDetailsLayout />
    </AnalyticsDependencyProvider>
  );
}

export { useAnalyticsDeps };
